function Tag({ tagName }) {

  return (
      <span >{tagName}</span>
  )
}

export default Tag